import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';

import { Countdown, AuctionStatuses, PartyTypes } from 'vdlib';

const AuctionNotification = ({
  auctionFinished,
  endDate,
  hasBids,
  onAuctionFinish,
  partyTypeDescription,
  status,
}) => {
  const [finished, setFinished] = React.useState(false);

  if (status === AuctionStatuses.Active && !finished)
    return (
      <div className="note note-info">
        <Countdown
          endDate={endDate}
          onFinish={() => {
            setFinished(true);
            onAuctionFinish();
          }}
        />
      </div>
    );

  const isFinished = status === AuctionStatuses.ForSelection || auctionFinished;

  return isFinished ? (
    <div
      className={`note note-${
        partyTypeDescription === PartyTypes.Merchant ? 'danger' : 'success'
      }`}
    >
      <p>
        {I.t('AUCTION_ENDED')}
        {(partyTypeDescription === PartyTypes.Insurance ||
          partyTypeDescription === PartyTypes.Admin_Insurance ||
          partyTypeDescription === PartyTypes.Operator) &&
        hasBids !== true
          ? I.t('NO_OFFERS_CONTINUE')
          : ''}
      </p>
      {partyTypeDescription === PartyTypes.Insurance && hasBids === true ? (
        <p>{I.t('OFFER_CHOSE_ONE_FROM_THEM')}</p>
      ) : (
        false
      )}
    </div>
  ) : status === AuctionStatuses.Pending ? (
    <div className="note">
      <p>{I.t('AUCTION_NOT_STARTED_YET')}</p>
    </div>
  ) : status === AuctionStatuses.ForAcceptance ? (
    <div className="note note-danger">
      <p>
        {partyTypeDescription === PartyTypes.Merchant
          ? I.t('OFFER_ACCEPTED_RESPONE')
          : I.t('WAITING_FOR_ACCEPT_FROM_MERCHANT')}
      </p>
    </div>
  ) : status === AuctionStatuses.ForDispatch ? (
    <div className="note note-danger">
      <p>{I.t('PARTS_DELIVERY')}</p>
    </div>
  ) : status === AuctionStatuses.Finished ? (
    <div className="note note-danger">
      <p>{I.t('COMPLETED')}</p>
    </div>
  ) : status === AuctionStatuses.DispatchProblem ? (
    <div className="note note-danger">
      <p>{I.t('PARTS_DELIVERY_PROBLRM')}</p>
    </div>
  ) : (
    <div className="note note-danger">
      <p>{I.t('AUCTION_CANCELED')}</p>
    </div>
  );
};

AuctionNotification.propTypes = {
  countdown: PropTypes.object,
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  hasBids: PropTypes.bool.isRequired,
  onAuctionFinish: PropTypes.func.isRequired,
  partyTypeDescription: PropTypes.string,
  status: PropTypes.string.isRequired,
  startDate: PropTypes.object,
};

export default AuctionNotification;
